import { Messages } from '../../codegen/Localize';

export interface IReactTranslateService {
  (translationId: string, interpolateParams?: any, interpolationId?: string): string;
}

export namespace TypeUnsafeTranslation {
  export function translate(key: string): string {
    return (Messages as any)[key]();
  }
}
